export const SET_ADDRESS = "SET_ADDRESS";
export const ADDRESSES_RECEIVED = "ADDRESSES_RECEIVED";
export const SET_PROPERTY_ADDRESS = "SET_PROPERTY_ADDRESS";
